import {
  type UseMutationResult,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { apiPut } from "@/shared/api";
import { useCurrentBoardSlug } from "@/shared/hooks/useCurrentBoardSlug";

interface DelParams {
  threadId: string;
  // ThreadDetailPost.postNumber は server schema 上 string なので string で受ける。
  // 新API path param は number 型だが URL 文字列化で問題なし。
  postNumber: string;
}

// 新API: PUT /reactions/{slug}/{threadId}/{postNumber}?actionType=del
// request body なし、actionType をクエリパラメータで指定 (spec §8 / Task 1.5)
// fingerprint 依存は撤去 (Cloudflare 側で識別子を付与)
export function useDelMutation(): UseMutationResult<
  undefined,
  unknown,
  DelParams
> {
  const queryClient = useQueryClient();
  const slug = useCurrentBoardSlug();

  return useMutation({
    mutationFn: async ({
      threadId,
      postNumber,
    }: DelParams): Promise<undefined> => {
      // request body なし。OpenAPI strict validation を避けるため {} も渡さない
      // 204 / 空 body は client.ts の unwrap が undefined を返す
      await apiPut<void>(
        `/reactions/${slug}/${threadId}/${postNumber}?actionType=del`,
      );
      return undefined;
    },
    onSuccess: (_data: undefined, variables: DelParams) => {
      const { threadId } = variables;
      queryClient.invalidateQueries({ queryKey: ["thread", slug, threadId] });
      // Task 8b で導入した reactions 集計の invalidate
      queryClient.invalidateQueries({
        queryKey: ["reactions", slug, threadId],
      });
      queryClient.invalidateQueries({ queryKey: ["threads", slug] });
    },
    onError: (error: unknown, params: DelParams) => {
      console.warn("delに失敗しました", { error, ...params });
    },
  });
}
